import { axiosInstance as request } from '@api/rest.service'

const api = id => {
  if (!!id) return `/subscription-periods/${id}/workflow`
  return '/subscription-periods/workflow'
}

/**
 * @description POST /subscription-periods/{id}/workflow/start
 * @returns {AxiosPromise<any>}
 */
export const START_WORKFLOW_FOR_PERIOD = periodId => request.post(`${api(periodId)}/start`)

/**
 * @description POST /subscription-periods/{id}/workflow/cancel
 * @returns {AxiosPromise<any>}
 */
export const CANCEL_WORKFLOW_FOR_PERIOD = periodId => request.post(`${api(periodId)}/cancel`)

/**
 * @description POST /subscription-periods/{id}/workflow/dismiss
 * @returns {AxiosPromise<any>}
 */
export const DISMISS_WORKFLOW_FOR_PERIOD = periodId => request.post(`${api(periodId)}/dismiss`)

/**
 * @description POST /subscription-periods/workflow/start
 * @returns {AxiosPromise<any>}
 */
export const START_WORKFLOW = () => request.post(`${api()}/start`)

/**
 * @description POST /subscription-periods/workflow/cancel
 * @returns {AxiosPromise<any>}
 */
export const CANCEL_WORKFLOW = () => request.post(`${api()}/cancel`)

/**
 * @description POST /subscription-periods/workflow/dismiss
 * @returns {AxiosPromise<any>}
 */
export const DISMISS_WORKFLOW = () => request.post(`${api()}/dismiss`)
